
import { PortfolioData, PaymentMethod, DiscountCode } from './types';

// Portfolio-specific data object (empty to start)
export const portfolioSpecificData: PortfolioData = {};

// Payment methods - same for all portfolios for simplicity
export const defaultPaymentMethods: PaymentMethod[] = [{
  id: "card1",
  type: "MasterCard",
  last4: "4456",
  exp: "1/23",
  isPrimary: true
}, {
  id: "card2",
  type: "MasterCard",
  last4: "1213",
  exp: "5/25",
  isPrimary: false
}];

// Discount codes - same for all portfolios for simplicity
export const defaultDiscountCodes: DiscountCode[] = [{
  code: "CYZ",
  amount: "$100 OFF",
  expires: "10/24",
  usesLeft: 1
}];
